import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import UserList from '../views/user/UserList.vue'
import SetUserList from '../views/user/SetUserList.vue'
import CategoryList from '../views/category/CategoryList.vue'
import ProductList from '../views/product/ProductList.vue'
import OrderList from '../views/order/OrderList.vue'
import RightsList from '../views/power/RightsList.vue'
import RoleList from '../views/power/RoleList.vue'
import RecordList from '../views/record/RecordList.vue'
import FruitList from '../views/fruit/fruitList.vue'
import FormulaList from '../views/formula/formulaList.vue'
import Device from '../views/device/DeviceList.vue'
import Register from '../views/Register'
import AppEditionList from '../views/appedition/AppEditionList.vue'
import FirmwareEditionList from '../views/firmwareedition/FirmwareEditionList.vue'
import FrimwareRecordList from '../views/frimwarerecord/FrimwareRecordList.vue'
import TrackList from '../views/track/trackList.vue'
import MapList from '../views/track/mapList.vue'
import axios from "axios"
import Login2 from '../views/zhengtusensorLogin.vue'
import NoticeList from '../views/notice/noticeList.vue'
import GjdeviceList from '../views/gjdevice/gjdeviceList.vue'
import questionList from '../views/question/questionList.vue'
import resetPassword from '../views/resetPassword'


Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        component: Login2
    },
    {
        path: '/login',
        component: Login2
    },
    {
        path: '/register',
        component: Register
    },
    {
        path: '/resetPassword',
        component: resetPassword
    },
    {
        path: '/home',
        component: Home,
        children: [
            {
                path: '/userList',
                component: UserList
            },
            {
                path: '/setUserList',
                component: SetUserList
            },
            {
                path: '/categoryList',
                component: CategoryList
            },
            {
                path: '/productList',
                component: ProductList
            },
            {
                path: '/orderList',
                component: OrderList
            },
            {
                path: '/rightsList',
                component: RightsList
            },
            {
                path: '/roleList',
                component: RoleList
            },
            {
                path: '/recordList',
                component: RecordList
            },
            {
                path: '/fruitList',
                component: FruitList
            },
            {
                path: '/formulaList',
                component: FormulaList
            }
            ,
            {
                path: '/appEditionList',
                component: AppEditionList
            }
            ,
            {
                path: '/firmwareEditionList',
                component: FirmwareEditionList
            }
            ,
            {
                path: '/frimwareRecordList',
                component: FrimwareRecordList
            },
            {
                path: '/deviceList',
                component: Device
            },
            {
                path: '/trackList',
                component: TrackList,
                meta:{
                    keepAlive:true
                }
            },
            {
                path: '/mapList',
                component: MapList
            },
            {
                path: '/noticeList',
                component: NoticeList
            },
            {
                path: '/gjdeviceList',
                component: GjdeviceList
            },
            {
                path: '/questionList',
                component: questionList
            }
        ]
    }
];

const router = new VueRouter({
    routes
});

// 路由控制守卫,解决需要登录才可以访问的页面
router.beforeEach((to, from, next) => {
    // 如果访问的首页直接放行
    if (to.path === '/login' || to.path === '/register') return next();
    // 获取token
    const tokenStr = window.sessionStorage.getItem('Authorization');
    // 没有token放回登录界面
    // if (!tokenStr) return next('/login');
    // 有token放行
    return next()
});

axios.interceptors.request.use((config) => {
    config.headers.Authorization = window.sessionStorage.getItem('Authorization');
    return config
});

// axios 配置
axios.defaults.baseURL = 'http://brix.zhengtusensor.com:8888/zhengtusensor';

// axios.defaults.baseURL = 'http://localhost:8888/fruit-java-api';
Vue.prototype.$http = axios;

export default router
